import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { updateNavbarHeading } from "../../../constants/layout/store/filterSlice";
import Dynamic_PR_table from "../../../components/Dynamic_PR_table";
import Select from "react-select";
import { toast } from "react-toastify";
import { API_URL } from "../../../constants";
import {
  GetServiceCaller,
  PostServiceCaller,
} from "../../../services/serviceCaller";
import * as Yup from "yup";

const ContractorsFee = () => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(updateNavbarHeading("Contractors Fee"));
  }, []);

  const initialFormData = {
    SubContractorID: "",
    Months: "",
    MonthlyPay: "",
  };

  const [contractorFee, setContractorFee] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [name, setName] = useState([]);
  const [month, setMonth] = useState([]);
  const [errors, setErrors] = useState([]);
  const [formData, setFormData] = useState(initialFormData);
  const [apiStatus, SetApiStatus] = useState(undefined);

  const resetFormState = () => {
    setFormData({
      SubContractorID: "",
      Months: "",
      MonthlyPay: "",
    });
    setIsEditMode(false);
  };

  const columns = {
    ID: { text: "ID", align: "center", visible: true },
    Name: { text: "Contractor Name", align: "start", visible: true },
    Months: { text: "Month", align: "center", visible: true },
    MonthlyPay: { text: "Monthly Fee", align: "end", visible: true },
  };

  const fetchContractorsFee = async () => {
    try {
      const response = await GetServiceCaller(
        `${API_URL}sub-contractor-payroll`
      );
      SetApiStatus(response?.status);
      const data = response?.data?.data;
      const formattedData = data.map((item) => ({
        ...item,
        MonthlyPay: new Intl.NumberFormat("en-IN", {
          //   style: "currency",
          currency: "INR",
          minimumFractionDigits: 0,
        }).format(item.MonthlyPay),
      }));

      setContractorFee(formattedData);
      const contractorName = response?.data?.subcontractor;
      const name = contractorName.map((comp) => ({
        value: comp.value,
        label: comp.text,
      }));
      setName(name);
      const monthlist = response?.data?.month;
      const month = monthlist.map((comp) => ({
        value: comp.value,
        label: comp.text,
      }));
      setMonth(month);
    } catch (error) {
      console.error("Error fetching skills:", error);
    }
  };
  useEffect(() => {
    fetchContractorsFee();
  }, []);

  const handleAddForm = () => {
    setShowModal(true);
    resetFormState();

    if (month?.length > 0) {
      setFormData((prev) => ({
        ...prev,
        Months: month[0]?.value,
      }));
    }
  };

  const schema = Yup.object().shape({
    SubContractorID: Yup.string().required("Sub Contractor is required"),
    Months: Yup.string().required("Months is required"),
    MonthlyPay: Yup.string().required("Monthly Fee is required"),
  });

  const validateField = async (fieldName, updatedData) => {
    try {
      await schema.validateAt(fieldName, updatedData);
      setErrors((prevErrors) => ({ ...prevErrors, [fieldName]: "" }));
    } catch (err) {
      if (err.path === fieldName) {
        setErrors((prevErrors) => ({
          ...prevErrors,
          [fieldName]: err.message,
        }));
      }
    }
  };
  const handleInputChange = async (e) => {
    const { name, value } = e.target;

    // Update the field only if it's part of the schema
    if (schema.fields[name]) {
      const updatedData = { ...formData, [name]: value };
      setFormData(updatedData);
      validateField(name, updatedData);
    }
  };
  const handleSelectChange = (selectedOption, { name }) => {
    if (schema.fields[name]) {
      const updatedData = { ...formData, [name]: selectedOption.value };
      setFormData(updatedData);
      validateField(name, updatedData);
    }
  };


  const [modalName, setModalName] = useState("")
  const handleEdit = async (id) => {
    setModalName("Edit")
    setShowModal(true);
    setIsEditMode(true);
    try {
      const response = await GetServiceCaller(
        `${API_URL}sub-contractor-payroll/${id.ID}`
      );

      if (response.status === 200) {
        const contractData = response?.data?.data;

        if (contractData) {
          const { SubContractorID, Months, MonthlyPay } = contractData;
          // Update form data with fetched values
          setFormData({
            id: id.ID,
            SubContractorID: SubContractorID || "",
            Months: Months || "",
            MonthlyPay: MonthlyPay || "",
          });
        }
      } else {
        console.error(
          "Failed to fetch Contractor details. Server responded with status:",
          response.status
        );
      }
    } catch (error) {
      console.error("Error fetching Contractor details:", error);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await schema.validate(formData, { abortEarly: false });
      setErrors({});

      const method = isEditMode ? "put" : "post";
      const url = isEditMode
        ? `${API_URL}sub-contractor-payroll/${formData.id}` // For PUT (update case)
        : `${API_URL}sub-contractor-payroll`; // For POST (create case)

      const response = await PostServiceCaller(url, formData, method);
      toast.success(
        formData.id
          ? "Form updated successfully!"
          : "Form submitted successfully!"
      );

      resetFormState();
      fetchContractorsFee();
      setIsEditMode(false);
      setFormData(initialFormData);
      setShowModal(false);
      setModalName("")
    } catch (error) {
      if (error.inner) {
        const newErrors = {};
        error.inner.forEach((err) => {
          newErrors[err.path] = err.message;
        });
        setErrors(newErrors);
      } else {
        console.error("Error submitting form:", error);
        toast.error("Something went wrong. Please try again.");
      }
    }
  };
  const handleEditModalClose = () => {
    setShowModal(false);
    resetFormState();
     setModalName("")
  };
  useEffect(() => {
    if (showModal && month?.length > 0) {
      setFormData((prev) => ({
        ...prev,
        Months: month[0]?.value,
      }));
    }
  }, [showModal, month]);

  return (
    <>
      <div className="container-fluid" id="skill_section">
        <div className="container-fluid" id="skill-table-area">
          <div className="row mt-2">
            <Dynamic_PR_table
              data={contractorFee}
              columns={columns}
              itemsPerPage={8}
              searchTerm={searchTerm}
              setSearchTerm={setSearchTerm}
              showIcon1={true}
              isSorting={true}
              isApiStatus={apiStatus}
              isRequiredStatus={true}
              isAddNewBtnRequired={true}
              isActionRequired={true}
              handleAddNew={handleAddForm}
              handleIcon1={handleEdit}
              icons={{
                Icon1: <i className="bi bi-pencil-square icons"></i>,
                // Icon1Flag:[]
              }}
            />
          </div>
        </div>
      </div>
      {showModal && (
        <div
          className="modal"
          tabIndex="-1"
          role="dialog"
          style={{
            display: "block",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
          }}
        >
          <div
            className="modal-dialog modal-dialog-centered modal-lg"
            role="document"
          >
            <div className="modal-content">
              <div className="modal-header" style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          borderBottom: '1px solid #f0f0f0',
          backgroundColor: '#f8f9fa',
          borderRadius: '8px 8px 0 0'
        }}>
                <p style={{
            fontSize: '20px',
            fontWeight: '600',
            color: '#27568B',
            margin: '0'
          }}>{modalName ? modalName : "Add"} Contractors Fee</p>
                <span className="me-2">
                  <i className="bi bi-x-lg" onClick={handleEditModalClose}></i>
                </span>
              </div>
              <div className="modal-body">
                <form onSubmit={handleSubmit}>
                  <div className="row">
                    <div className="col-md-4">
                      <div class="mb-3">
                        <label for="Code" class="form-label">
                          Sub Contractor<span className="required">*</span>
                        </label>
                        <Select
                          value={name.find(
                            (option) =>
                              option.value === formData.SubContractorID
                          )}
                          options={name}
                          onChange={handleSelectChange}
                          name="SubContractorID"
                        />
                        {errors.SubContractorID && (
                          <div className="text-danger">
                            {errors.SubContractorID}
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div class="mb-3">
                        <label for="Code" class="form-label">
                          Month<span className="required">*</span>
                        </label>
                        <Select
                          value={month.find(
                            (opt) =>
                              opt.value === (formData.Months || month[0]?.value)
                          )}
                          options={month}
                          onChange={handleSelectChange}
                          name="Months"
                        />
                        {errors.Months && (
                          <div className="invalid-feedback">
                            {errors.Months}
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div class="mb-3">
                        <label for="Code" class="form-label">
                          Monthly fee<span className="required">*</span>
                        </label>
                        <input
                          type="text"
                          className={`form-control ${errors.MonthlyPay ? "is-invalid" : ""
                            }`}
                          id="MonthlyPay"
                          aria-describedby="MonthlyPay"
                          name="MonthlyPay"
                          placeholder="Monthly Fee"
                          value={formData.MonthlyPay || ""}
                          onChange={handleInputChange}
                        />
                        {errors.MonthlyPay && (
                          <div className="invalid-feedback">
                            {errors.MonthlyPay}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>

                  <div className="text-end mt-2">
                    <button
                      className="cancel-btn me-2"
                      onClick={handleEditModalClose}
                    >
                      Cancel
                    </button>
                    <button type="submit" className="custom-btn">
                      Submit
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ContractorsFee;
